export const hasValidQualifications = ({ context }) => {
    return Boolean(context.qualifications && context.qualifications.length > 0);
};
export const hasSuspensionReason = ({ context }) => {
    return Boolean(context.suspensionReason);
};
//# sourceMappingURL=tutor.js.map